import _get from 'lodash/get';

export const getSelectorTabs = data => {
  const blocks = _get(data, 'block.alternativeContent.concurrentBlocks') || [];

  return {
    tabs: blocks.map(({ id, title }) => ({
      id,
      title,
    })),
    blocks,
  };
};

export const getRendererRefByIndex = index => `Renderer_${index}`;
